// ApexCharts için TÜRKÇE yerel ayar.
//
// Neden gerekli: zaman eksenini ApexCharts'ın kendi TimeScale'i etiketliyor ve
// varsayılan ay adları İNGİLİZCE ("24 Aug 06:00"). Uygulamanın tamamı Türkçe.
//
// Neden `xaxis.labels.formatter` DEĞİL: formatter verildiği anda ApexCharts
// TimeScale'i TAMAMEN atlıyor (Core.js, `labels.formatter === undefined`
// koşulu) ve tikler saat sınırlarına oturmayı bırakıyor — ölçüldü: 24 saatlik
// pencerede 6 saatlik 4 temiz tik yerine 80 dakikalık, hiçbir yuvarlak saate
// denk gelmeyen tikler çıkıyor. Yerel ayar bu ödünleşimi hiç kurmuyor:
// TimeScale çalışmaya devam ediyor, yalnız ad tabloları değişiyor.
//
// `datetimeUTC: false` ile birlikte kullanılıyor; tarayıcı dilimi
// Europe/Istanbul olduğu için saatler yerel görünüyor.

import type { ApexLocale, ApexOptions } from 'apexcharts'

// `as const` KULLANILMIYOR: ApexLocale alanları `string[]` bekliyor ve
// readonly demet ona atanamıyor.
const TR_LOCALE: ApexLocale = {
  name: 'tr',
  options: {
    months: [
      'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
      'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
    ],
    shortMonths: [
      'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz',
      'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara',
    ],
    days: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    shortDays: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
  },
}

/** Her grafiğin `chart` bloğuna yayılacak yerel ayar. */
export const YEREL: Pick<NonNullable<ApexOptions['chart']>, 'locales' | 'defaultLocale'> = {
  locales: [TR_LOCALE],
  defaultLocale: 'tr',
}
